import styled from 'styled-components';

import { IconTick } from '@xing-com/icons';
import {
  scale200,
  spaceM,
  spaceXL,
  xdlColorInfoSoft,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const Container = styled.section`
  margin-bottom: ${scale200};
`;

export const InsightWrapper = styled.div`
  display: flex;
  margin: ${spaceXL} 0;

  & > svg {
    margin-right: ${spaceXL};
  }
`;

export const Icon = styled(IconTick)`
  background-color: ${xdlColorInfoSoft};
  border-radius: 100px;
  padding: ${spaceM};
`;

export const Text = styled(BodyCopy)`
  color: ${xdlColorTextSecondary};
  flex: 1;
`;
